/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'

interface PageFrameProps {
  header?: React.ReactNode
  content?: React.ReactNode
}

const PageFrame = React.forwardRef<HTMLDivElement, PageFrameProps>(({ header, content }, ref) => {
  return (
    <div className="mcc-content-frame theme-sandman">
      {header && <div className="sub-page-header">{header}</div>}

      <div id="page-content">{content}</div>

      <div ref={ref}>{/*used as modal container*/}</div>
    </div>
  )
})

PageFrame.displayName = 'PageFrame'

export default PageFrame
